<div class="baja-servicio-container">
  <div class="Titulo">Solicitud de baja del servicio</div>
  <div class="form-container">
    <form [formGroup]="bajaForm" (ngSubmit)="onSubmit()" id="formulario">
      <div class="form-group">
        <span>Nombre *</span>
        <input
          type="text"
          formControlName="nombre"
          placeholder="Nombre *"
          [class.invalid]="
            bajaForm.get('nombre').invalid && bajaForm.get('nombre').touched
          "
        />
        <div
          class="error-message"
          *ngIf="
            bajaForm.get('nombre').invalid && bajaForm.get('nombre').touched
          "
        >
          El nombre es obligatorio
        </div>
      </div>

      <div class="form-group">
        <span>Apellido *</span>
        <input
          type="text"
          formControlName="apellido"
          placeholder="Apellido *"
          [class.invalid]="
            bajaForm.get('apellido').invalid && bajaForm.get('apellido').touched
          "
        />
        <div
          class="error-message"
          *ngIf="
            bajaForm.get('apellido').invalid && bajaForm.get('apellido').touched
          "
        >
          El apellido es obligatorio
        </div>
      </div>

      <div class="form-group">
        <span>Número de Socio / código Área Protegida *</span>
        <input
          type="text"
          formControlName="nro_socio"
          placeholder="Número de Socio / código Área Protegida *"
          [class.invalid]="
            bajaForm.get('nro_socio').invalid &&
            bajaForm.get('nro_socio').touched
          "
        />

        <div
          class="error-message"
          *ngIf="
            bajaForm.get('nro_socio').invalid &&
            bajaForm.get('nro_socio').touched
          "
        >
          El número de socio es obligatorio
        </div>
      </div>

      <div class="form-group">
        <span>Teléfono *</span>
        <input
          type="tel"
          formControlName="telefono"
          placeholder="Teléfono *"
          [class.invalid]="
            bajaForm.get('telefono').invalid && bajaForm.get('telefono').touched
          "
        />

        <div
          class="error-message"
          *ngIf="
            bajaForm.get('telefono').invalid && bajaForm.get('telefono').touched
          "
        >
          Ingrese un número de teléfono válido
        </div>
      </div>
      <div class="form-group">
        <span>Email *</span>
        <input
          type="email"
          formControlName="email"
          placeholder="Email *"
          [class.invalid]="
            bajaForm.get('email').invalid && bajaForm.get('email').touched
          "
        />
        <div
          class="error-message"
          *ngIf="bajaForm.get('email').invalid && bajaForm.get('email').touched"
        >
          {{ getEmailErrorMessage() }}
        </div>
      </div>

      <div class="form-group">
        <span>Motivo de la baja</span>
        <textarea
          formControlName="comentario"
          placeholder="Comentarios"
          rows="4"
          [class.invalid]="
            bajaForm.get('comentario').invalid &&
            bajaForm.get('comentario').touched
          "
        ></textarea>
      </div>

      <div class="form-actions">
        <button
          type="submit"
          [disabled]="bajaForm.invalid || isSubmitting"
          class="submit-button"
        >
          {{ isSubmitting ? "Enviando..." : "Enviar solicitud" }}
        </button>
      </div>

      <div class="error-message submit-error" *ngIf="submitError">
        {{ submitError }}
      </div>
    </form>
  </div>
</div>
